/**
 * Sign up process.
 */

'use strict';

var helper = require('../misc/helpers');

// Constructor
var FrontSignup = function () {
    if (!$('body').hasClass('signup')) {
        return;
    }

    $(document).ready((function () {
        this.setAccountTypesHeight();
        this.setAccountTypesHighlight();
        this.initSignupFormActor();
        this.initSignupFormPro();

        if ($('body').hasClass('signup-actor')) {
            this.submitSignupFormActor();
        }

        if ($('body').hasClass('signup-visiteur-pro')) {
            this.submitSignupFormPro();
        }

        if ($('body').hasClass('signup-photograph')) {
            this.initSignupFormPhotograph();
            this.submitSignupFormPhotograph();
        }
    }).bind(this));
};

FrontSignup.prototype = {
    lockAjaxForm: false,
    lockAjaxCalculatePwdStrength: false,
    lockAjaxCheckName: false,

    setAccountTypesHeight: function() {
        $('.account-types .box .middle').matchHeight();
        $('.account-types .box .bottom').matchHeight();
    },

    setAccountTypesHighlight: function() {
        $('.account-types .box').on({
            mouseenter: function () {
                $(this).parent().find('.box.hover').removeClass('hover');
                $(this).addClass('hover');

                $(this).parent().find('.box:not(.hover)').each(function () {
                    $(this).addClass('hover-other');

                    /*$(this).find('.inner').stop().animate({opacity: 0.7}, 250, function () {
                        $(this).addClass('hover-other');
                    });*/
                });
            },
            mouseleave: function () {
                //$(this).parent().find('.box:not(.hover) .inner').removeAttr('style');
                $(this).parent().find('.box:not(.hover)').removeClass('hover-other');
                $(this).parent().find('.box.hover').removeClass('hover');
            }
        });
    },

    initSignupFormActor: function() {
        var self = this;

        // Initialize the Materialize components

        $('.row-form select').formSelect();

        // Dropdown validation (required field)
        // + bug fix (see https://github.com/Dogfalo/materialize/issues/1861)

        $('.row-form select[required]').css({
            display: 'block',
            position: 'absolute',
            height: 0,
            padding: 0,
            width: 0
        });

        $('.row-form select[required]').change(function() {
            var input = $(this).parent().find('input.select-dropdown');
            if ($(this).val() != '') {
                input.addClass('valid');
            } else {
                input.removeClass('valid');
            }
        });

        $('.row-form .select-dropdown li').each(function() {
            if ($(this).text() == '--') {
                $(this).addClass('disabled');
            }
        });

        // Password confirmation

        $('#passwordConfirm').on('input', function() {
            if ($(this).val() !== $('#password').val()) {
                $(this).removeClass('valid').addClass('invalid');
            } else {
                $(this).removeClass('invalid').addClass('valid');
                $(this).blur();
            }
        });

        // Show or hide special field for students

        $('.row-form #status').change(function() {
            if ($(this).val() == 'actor') {
                $('.wrapper-studentProof').fadeOut();
            } else {
                $('.wrapper-studentProof').fadeIn();
            }
        });

        // Show or hide special field for non-switzerland inhabitant

        $('.row-form #nationality').change(function() {
            if ($(this).val() == 'ch') {
                $('.wrapper-residence-permit').fadeOut();
                $('.wrapper-residencePermitFile').fadeOut();
                $('.wrapper-idcard').fadeIn();
            } else {
                $('.wrapper-residence-permit').fadeIn();
                $('.wrapper-residencePermitFile').fadeIn();
                $('.wrapper-idcard').fadeOut();
            }
        });

        // Enabled or disable the submit button depending on the checkbox term of use

        var tosSubmitButton = function() {
            if ($('.signup-actor #tosAgree').is(':checked') ) {
                $('.signup-actor .row-form .btn-submit').removeClass('disabled');
            } else {
                $('.signup-actor .row-form .btn-submit').addClass('disabled');
            }
        };

        $('.signup-actor #tosAgree').change(function() {
            tosSubmitButton();
        });

        tosSubmitButton();

        // File input

        $('.row-form #studentProof').change(function(){
            var file = this.files[0];

            if (file && typeof file.name !== 'undefined') {
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/gif'];
                if (allowedTypes.indexOf(file.type) == -1) {
                    M.toast({html:'<span>'+ comedien.i18n.signupInvalidFileType +'</span>'}, 5000);
                }
                if (file.size > 5242880) { // 5 Mo
                    M.toast({html:'<span>'+ comedien.i18n.signupInvalidFileSize +'</span>'}, 5000);
                }
            }
        });

        // Password strength meter with zxcvbn

        //this.initPasswordStrenghMeter();

        // Check the password complexity (without using the zxcvbn library... what's a pitty... :/)

        this.initPasswordCheckComplexity();



        this.createBirthdayDatepicker();

       /* $('.row-form #birthdate').pickadate({
            container: '#site-header',
            format: 'dd.mm.yyyy',
            formatSubmit: 'yyyy-mm-dd',
            selectYears: 100,
            selectMonths: true,
            firstDay: 1,
            monthsFull: monthsFull,
            today: '',
            clear: comedien.i18n.pickadateClear,
            close: comedien.i18n.pickadateClose,
            min: new Date(1900,1,1),
            max: new Date(), // today
            weekdaysFull: weekdaysFull,
            weekdaysLetter: weekdaysLetter,
            onRender: function () {
                var idPicker = this.get('id');
                var monthValue = $('#' + idPicker + '_root').find('.picker__month-display > div').html();
                var yearValue = $('#' + idPicker + '_root').find('.picker__year-display > div').html();
            },
            onClose: function () {
                // Get the value
                var value = this.get();

                if (value != '') {
                    var split = value.split('.');
                    var datetime = split[2] + '-' + split[1] + '-' + split[0];

                    if (datetime.length == 10) {
                        $('.row-form #birthdateDatetime').val(datetime);
                        $('.row-form #birthdate').removeClass('force-invalid').addClass('force-valid');
                    } else {
                        $('.row-form #birthdateDatetime').val('');
                        $('.row-form #birthdate').removeClass('force-valid').addClass('force-invalid');
                    }

                    $('.input-field label[for="birthdate"]').addClass('active');
                } else {
                    $('.row-form #birthdateDatetime').val('');
                    $('.row-form #birthdate').removeClass('force-valid').addClass('force-invalid');
                    $('.input-field label[for="birthdate"]').removeClass('active');
                }
            },
        });*/

        // Check homonym

        var typingTimerLastname;
        var doneTypingInterval = 1500;

        var checkNameExist = function() {
            var firstname = $('#firstname').val();
            var lastname = $('#lastname').val();

            if (firstname == '' || lastname == '') {
                return;
            }

            if (self.lockAjaxCheckName) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxCheckName = true;

            var ajaxAction = 'signup.checkname';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&firstname=" + firstname + "&lastname=" + lastname,
            }).done(function(response) {
                if (response.success == true) {
                    $('.input-field-lastname .info').hide();
                } else {
                    if (response.data.email != '') {
                        $('.input-field-lastname .info .email').html(response.data.email);
                        $('.input-field-lastname .info').show();
                    } else {
                        $('.input-field-lastname .info').hide();
                    }
                }

                self.lockAjaxCheckName = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxCheckName = false;
            });
        };

        $('#lastname').on('keyup', function () {
            clearTimeout(typingTimerLastname);
            typingTimerLastname = setTimeout(checkNameExist, doneTypingInterval);
        });

        $('#lastname').on('keydown', function () {
            clearTimeout(typingTimerLastname);
        });

        $('#lastname').focusout(function() {
            checkNameExist();
        });
    },

    createBirthdayDatepicker: function () {
        var self = this;

        // Date picker for the birthdate

        var monthsFull = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        var weekdaysFull = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        var weekdaysShort = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
        var weekdaysLetter = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];

        $('#birthdate').datepicker({
            container: '#site-header',
            format: 'dd.mm.yyyy',
            minDate: new Date(1900,1,1),
            maxDate: new Date(),
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            yearRange: [1900, 2019],
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: weekdaysShort,
                weekdaysLetter: weekdaysLetter,
                weekdays:weekdaysFull,
                months: monthsFull
            },
            onSelect: function(date) {

            },
            onDraw: function() {

            },
            onOpen: function() {

            },
            onClose: function () {

                if (typeof this.date === 'undefined')
                    return;

                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }

                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (datetime.length >= 9) {
                        $('.row-form #birthdateDatetime').val(datetime);
                        $('.row-form #birthdate').removeClass('force-invalid').addClass('force-valid');
                    } else {
                        $('.row-form #birthdateDatetime').val('');
                        $('.row-form #birthdate').removeClass('force-valid').addClass('force-invalid');
                    }
                    $('.input-field label[for="birthdate"]').addClass('active');
                } else {
                    $('.row-form #birthdateDatetime').val('');
                    $('.row-form #birthdate').removeClass('force-valid').addClass('force-invalid');
                    $('.input-field label[for="birthdate"]').removeClass('active');
                }
            },
        });
    },

    /**
     * Display or hide additional content for the steps
     *
     * @param stepHref
     */
    displayHideStepContent: function(stepHref) {
        if ($('body').hasClass('signup-visiteur-pro')) {
            if (stepHref == '#step3') {
                $('.row-form .col-left').hide();
                $('.row-form #step3-left').show();
            } else {
                $('.row-form .col-left').show();
                $('.row-form #step3-left').hide();
            }
        }

        if ($('body').hasClass('signup-photograph')) {
            if (stepHref == '#step2') {
                $('.row-form .col-left').hide();
                $('.row-form #step2-left').show();
            } else {
                $('.row-form .col-left').show();
                $('.row-form #step2-left').hide();
            }
        }
    },

    initSignupFormPro: function() {
        var self = this;

        $('.tabs').tabs();

        // Job
        $('.row-form #job').change(function() {
            if ($(this).val() == 'other') {
                $('.input-field-job-other').fadeIn();
            } else {
                $('.input-field-job-other').fadeOut();
                $('#job-other').val('');
            }
        });

        // Sectors
        $('.input-field-sectors :checkbox').change(function() {
            if (this.value == 'other') {
                if (this.checked) {
                    $('.input-field-sectors-other').fadeIn();
                } else {
                    $('.input-field-sectors-other').fadeOut();
                    $('#sectors-other').val('');
                }
            }
        });

        // Active tab on page load
        var activeTab = $('.tabs-signup li a.active');
        if (activeTab.length > 0) {
            self.displayHideStepContent(activeTab.attr('href'));
        }

        $('.tabs-signup li a').on('click', function() {
            if (!$(this).parent().hasClass('disabled')) {
                self.displayHideStepContent($(this).attr('href'));
            }
        });

        $('#updateStep1').on('click', function() {
            $('ul.tabs-signup').tabs('select', 'step1');
            self.displayHideStepContent('#step1');
        });

        $('#updateStep2').on('click', function() {
            $('ul.tabs-signup').tabs('select', 'step2');
            self.displayHideStepContent('#step2');
        });

        // International Telephone Input
        // translated in french with the help of @link https://github.com/harold-s/harold-s/tree/master/intl-tel-input-french-translation

        var countryData = $.fn.intlTelInput.getCountryData();
        $.each(countryData, function(i, country) {
            country.name = helper.hashCountryDataTranslation[country.iso2];
        });

        $('.row-form #phone').intlTelInput({
            autoPlaceholder: 'aggressive',
            utilsScript: comedien.assets + 'vendor/intl-tel-input/build/js/utils.js',
            initialCountry: 'ch',
            preferredCountries: ['ch', 'fr', 'be', 'de', 'it']
        });

        $('.intl-tel-input #phone').focusout(function () {
            var label = $(this).parent().parent().find("label[for='phone']");
            label.removeClass('active');
        }).focus(function() {
            var label = $(this).parent().parent().find("label[for='phone']");
            label.addClass('active');
        });

        // Enabled or disable the submit button depending on the checkbox term of use

        var tosSubmitButton = function() {
            if ($('.signup-visiteur-pro #tosAgree').is(':checked') ) {
                $('.signup-visiteur-pro .row-form #step3 .btn-submit').removeClass('disabled');
            } else {
                $('.signup-visiteur-pro .row-form #step3 .btn-submit').addClass('disabled');
            }
        };

        $('.signup-visiteur-pro #tosAgree').change(function() {
            tosSubmitButton();
        });
    },

    initSignupFormPhotograph: function() {
        // Enabled or disable the submit button depending on the checkbox term of use

        var tosSubmitButton = function() {
            if ($('.signup-photograph #tosAgree').is(':checked') ) {
                $('.signup-photograph .row-form #step2 .btn-submit').removeClass('disabled');
            } else {
                $('.signup-photograph .row-form #step2 .btn-submit').addClass('disabled');
            }
        };

        $('.signup-photograph #tosAgree').change(function() {
            tosSubmitButton();
        });
    },

    submitSignupFormActor: function() {
        var self = this;

        $('.signup-actor .row-form form').submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            var selfForm = $(this);

            $('#submit', selfForm).hide();
            $('.preloader-wrapper', selfForm).fadeIn();

            var ajaxAction = 'signup.form.actors';
            var formdata = false;
            if (window.FormData){
                formdata = new FormData(selfForm[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : selfForm.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function(response) {
                if (response.success) {
                    var url = $('#redirectTo', selfForm).val();
                    location.replace(url);
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, selfForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });

                    self.lockAjaxForm = false;

                    $('.preloader-wrapper', selfForm).fadeOut();
                    $('#submit', selfForm).show();
                }
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('.preloader-wrapper', selfForm).fadeOut();
                $('#submit', selfForm).show();

                console.log("Request failed: " + textStatus);
            });
        });
    },

    submitSignupFormPro: function() {
        var self = this;

        $('.signup-visiteur-pro .row-form form').submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            var selfForm = $(this);
            var step = $('input[name="step"]', selfForm).val();

            $('.btn-submit', selfForm).hide();
            $('.preloader-wrapper', selfForm).fadeIn();

            if (step == 1) {
                var intlNumber = $('.row-form #phone').intlTelInput('getNumber');
                $('.row-form #phoneInternational').val(intlNumber);
            }

            self.updateSummaryDataPro();

            self.submitSignupFormProRequest(function(response) {
                var lastStepRedirect = false;
                console.log(step)
                if (response.success) {
                    if (step == 1) {
                        // Go to step 2
                        $('ul.tabs .tab-step2').removeClass('disabled');
                        $('ul.tabs').tabs('select', 'step2');
                        self.displayHideStepContent('#step2');
                        $('html,body').animate({
                            scrollTop: 0
                        }, 700);
                    } else if (step == 2) {
                        if ($('#step1 #realisateur-de-showreel').is(':checked')) {
                            $('.type-contribution-2-amount').text('180');
                        } else {
                            $('.type-contribution-2-amount').text('290');
                        }

                        // Go to step 3 (final)
                        $('ul.tabs .tab-step3').removeClass('disabled');
                        $('ul.tabs').tabs('select', 'step3');
                        self.displayHideStepContent('#step3');
                        $('html,body').animate({
                            scrollTop: 0
                        }, 700);
                    } else if (step == 3) {
                        lastStepRedirect = true;
                        var url = $('#redirectTo', selfForm).val();
                        location.replace(url);
                    }
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, selfForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                if (lastStepRedirect != true) {
                    self.lockAjaxForm = false;

                    $('.preloader-wrapper', selfForm).fadeOut();
                    $('.btn-submit', selfForm).show();
                }
            }, function(jqXHR, textStatus) {
                M.toast({html:'<span>'+ comedien.i18n.anErrorOccured +'</span>'}, 5000);

                self.lockAjaxForm = false;

                $('.preloader-wrapper', selfForm).fadeOut();
                $('.btn-submit', selfForm).show();
            }, step);
        });
    },

    submitSignupFormPhotograph: function() {
        var self = this;

        $('.signup-photograph .row-form form').submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            var selfForm = $(this);
            var step = $('input[name="step"]', selfForm).val();

            $('.btn-submit', selfForm).hide();
            $('.preloader-wrapper', selfForm).fadeIn();

            if (step == 1) {
                var intlNumber = $('.row-form #phone').intlTelInput('getNumber');
                $('.row-form #phoneInternational').val(intlNumber);
            }

            self.updateSummaryDataPhotograph();

            self.submitSignupFormPhotographRequest(function(response) {
                var lastStepRedirect = false;

                if (response.success) {
                    if (step == 1) {
                        // Go to step 2 (final)
                        $('ul.tabs .tab-step2').removeClass('disabled');
                        $('ul.tabs').tabs('select', 'step2');
                        self.displayHideStepContent('#step2');
                        $('html,body').animate({
                            scrollTop: 0
                        }, 700);
                    } else if (step == 2) {
                        lastStepRedirect = true;
                        var url = $('#redirectTo', selfForm).val();
                        location.replace(url);
                    }
                } else {
                    $.each(response.data.errors, function (i, item) {
                        $('#' + i, selfForm).addClass('invalid');
                        M.toast({html:'<span>'+ item +'</span>'}, 5000);
                    });
                }

                if (lastStepRedirect != true) {
                    self.lockAjaxForm = false;

                    $('.preloader-wrapper', selfForm).fadeOut();
                    $('.btn-submit', selfForm).show();
                }
            }, function(jqXHR, textStatus) {
                M.toast({html:'<span>'+ comedien.i18n.anErrorOccured +'</span>'}, 5000);
                self.lockAjaxForm = false;

                $('.preloader-wrapper', selfForm).fadeOut();
                $('.btn-submit', selfForm).show();
            }, step);
        });
    },

    submitSignupFormProRequest: function(callbackDone, callbackFail, step) {
        var formData = '';

        if (step == 1) {
            formData = $('.row-form #form-step1').serialize();
        } else if (step == 2) {
            formData = $('.row-form #form-step1').serialize() + '&' + $('.row-form #form-step2').serialize();
        } else if (step == 3) {
            formData = $('.row-form #form-step1').serialize() + '&' + $('.row-form #form-step2').serialize() + '&' + $('.row-form #form-step3').serialize();
        }

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: formData + "&action=signup.form.pro&security=" + comedien.security,
        }).done(callbackDone).fail(callbackFail);
    },

    submitSignupFormPhotographRequest: function(callbackDone, callbackFail, step) {
        var formData = '';

        if (step == 1) {
            formData = $('.row-form #form-step1').serialize();
        } else if (step == 2) {
            formData = $('.row-form #form-step1').serialize() + '&' + $('.row-form #form-step2').serialize();
        }

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: formData + "&action=signup.form.photograph&security=" + comedien.security,
        }).done(callbackDone).fail(callbackFail);
    },

    updateSummaryDataPro: function() {
        // Data from step 1

        var sexe = $('#step1 #sexe').find(":selected").text();
        var firstname = $('#step1 #firstname').val()
        var lastname = $('#step1 #lastname').val()
        var job = $('#step1 #job').find(":selected").text();
        var phone = $('#step1 #phone').intlTelInput('getNumber');
        var email = $('#step1 #email').val();

        $('#step3-left .sexe').text(sexe);
        $('#step3-left .firstname').text(firstname);
        $('#step3-left .lastname').text(lastname);
        $('#step3-left .job').text(job);
        $('#step3-left .phone').text(phone);
        $('#step3-left .email').text(email);

        // Data from step 2

        var namerCompany = $('#step2 #namer-company').val();
        var namerPostalCode = $('#step2 #namer-address-postal-code').val();
        var namerCity = $('#step2 #namer-address-city').val();
        var namerCountry = $('#step2 #namer-address-country').find(":selected").text();
        var namerWebsite = $('#step2 #namer-website').val();

        $('#step3-left .namer-company').text(namerCompany);
        $('#step3-left .namer-address-postal-code').text(namerPostalCode);
        $('#step3-left .namer-address-city').text(namerCity);
        $('#step3-left .namer-address-country').text(namerCountry);
        $('#step3-left .namer-website').text(namerWebsite);
    },

    updateSummaryDataPhotograph: function() {
        // Data from step 1

        var type = $('#step1 #photograph-type').find(":selected").text();
        var sexe = $('#step1 #sexe').find(":selected").text();
        var firstname = $('#step1 #firstname').val()
        var lastname = $('#step1 #lastname').val()
        var phone = $('#step1 #phone').intlTelInput('getNumber');
        var email = $('#step1 #email').val();
        var website = $('#step1 #website').val();
        var street = $('#step1 #address-street').val();
        var postalCode = $('#step1 #address-postal-code').val();
        var city = $('#step1 #address-city').val();
        var country = $('#step1 #address-country').find(":selected").text();

        $('#step2-left .photograph-type').text(type);
        $('#step2-left .sexe').text(sexe);
        $('#step2-left .firstname').text(firstname);
        $('#step2-left .lastname').text(lastname);
        $('#step2-left .phone').text(phone);
        $('#step2-left .email').text(email);
        $('#step2-left .website').text(website);
        $('#step2-left .website').text(website);
        $('#step2-left .address-street').text(street);
        $('#step2-left .address-postal-code').text(postalCode);
        $('#step2-left .address-city').text(city);
        $('#step2-left .address-country').text(country);
    },

    initPasswordStrenghMeter: function() {
        var self = this;
        var typingTimer;
        var doneTypingInterval = 1500;

        if (!$('.row-form #password').length > 0) {
            return;
        }

        // Calculate the password strength from client side with the zxcvbn library
        var calculateStrength = function() {
            var password = $('.row-form #password').val();
            //var blacklist = [$('.row-form #firstname').val(), $('.row-form #lastname').val(), $('.row-form #email').val()];
            var blacklist = [];

            if (password.length == 0) {
                $('.row-form #password').removeClass('force-invalid').removeClass('force-warning').removeClass('force-valid');
                $('.pwd-strength').hide();
            } else {
                var result = zxcvbn(password, blacklist);
                //updateGraphicStrengthIndicator(result.score);
            }
        };

        // Calculate the password strength from server side with the zxcvbn library
        // We couldn't rely on the JS script because the score is different between the client-side and server-side.
        // @link https://github.com/bjeavons/zxcvbn-php/issues/15
        var calculateStrengthServerSide = function() {
            if (self.lockAjaxCalculatePwdStrength) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxCalculatePwdStrength = true;

            var password = $('.row-form #password').val();
            var ajaxAction = 'signup.passwordstrength';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: "action=" + ajaxAction + "&security=" + comedien.security + "&password=" + password,
            }).done(function(response) {
                if (response.success) {
                    var score = parseInt(response.data) || 0;
                    updateGraphicStrengthIndicator(score);
                }

                self.lockAjaxCalculatePwdStrength = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxCalculatePwdStrength = false;
            });
        };

        var updateGraphicStrengthIndicator = function(score) {
            switch (score) {
                case 0:
                    $('.row-form #password').removeClass('force-valid').removeClass('force-warning').addClass('force-invalid');
                    $('.pwd-strength span').text(comedien.i18n.signupPwdStrength1);
                    $('.pwd-strength').show();
                    break;
                case 1:
                    $('.row-form #password').removeClass('force-valid').removeClass('force-warning').addClass('force-invalid');
                    $('.pwd-strength span').text(comedien.i18n.signupPwdStrength1);
                    $('.pwd-strength').show();
                    break;
                case 2:
                    $('.row-form #password').removeClass('force-valid').removeClass('force-warning').addClass('force-invalid');
                    $('.pwd-strength span').text(comedien.i18n.signupPwdStrength2);
                    $('.pwd-strength').show();
                    break;
                case 3:
                    $('.row-form #password').removeClass('force-valid').removeClass('force-invalid').addClass('force-warning');
                    $('.pwd-strength span').text(comedien.i18n.signupPwdStrength3);
                    $('.pwd-strength').show();
                    break;
                case 4:
                    $('.row-form #password').removeClass('force-invalid').removeClass('force-warning').addClass('force-valid');
                    $('.pwd-strength').hide();
                    break;
            }
        };

        $('.row-form #email').on('input', function() {
            if ($('.row-form #password').val() != '') {
                calculateStrength();
            }
        });

        $('.row-form #lastname').on('input', function() {
            if ($('.row-form #password').val() != '') {
                calculateStrength();
            }
        });

        $('.row-form #firstname').on('input', function() {
            if ($('.row-form #password').val() != '') {
                calculateStrength();
            }
        });

        $('.row-form #password').on('input', function() {
            calculateStrength();
        });

        // For server side

        $('.row-form #password').on('keyup', function () {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(calculateStrengthServerSide, doneTypingInterval);
        });

        $('.row-form #password').on('keydown', function () {
            clearTimeout(typingTimer);
        });
    },

    initPasswordCheckComplexity: function() {
        if (!$('.row-form #password').length > 0) {
            return;
        }

        // Check if the password contain the required char (uppercase, min 8 char, etc.)
        var check = function() {
            var password = $('.row-form #password').val();

            var blacklist = [$('.row-form #firstname').val(), $('.row-form #lastname').val(), $('.row-form #email').val()];

            var patternEmail = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?');
            var inputEmail = $('.row-form #email').val();
            if (patternEmail.test(inputEmail)) {
                var username = inputEmail.substring(0, inputEmail.lastIndexOf("@"));
                blacklist.push(username); // Add the part before the "@"
            }

            blacklist = helper.cleanArray(blacklist);

            var result = true;

            // Check the password length
            if (password.length < 8) {
                result = false;
            }

            // Check if the password contains both lower and uppercase characters
            if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) == null) {
                result = false;
            }

            // Check blacklisted words

            if (blacklist.length > 0) {
                var regex = new RegExp(blacklist.join("|"), "gi");
                if (password.match(regex)) {
                    result = false;
                }
            }

            if (result == true) {
                // The password is valid
                $('.row-form #password').removeClass('force-invalid').removeClass('force-warning').addClass('force-valid');
                $('.row-form #passwordConfirm').val('').attr('disabled', false);
            } else {
                // The password is invalid
                $('.row-form #password').removeClass('force-valid').removeClass('force-warning').addClass('force-invalid');
                $('.row-form #passwordConfirm').val('').attr('disabled', 'disabled').removeClass('valid').removeClass('invalid');
            }
        };

        $('.row-form #email').on('input', function() {
            if ($('.row-form #password').val() != '') {
                check();
            }
        });

        $('.row-form #lastname').on('input', function() {
            if ($('.row-form #password').val() != '') {
                check();
            }
        });

        $('.row-form #firstname').on('input', function() {
            if ($('.row-form #password').val() != '') {
                check();
            }
        });

        $('.row-form #password').on('input', function() {
            check();
        });
    },
};

module.exports = new FrontSignup();
